import {Modal, RadioGroup, ModalTitle} from '@thryvlabs/maverick'
import React from 'react'

const data = [
  {
    name: 'Autopay',
    value: 'Credit Card',
  },
  {
    name: 'Invoice',
    value: 'Invoice',
  },
]

const BillingOptionsModal = ({
  setSelectedPaymentMethod,
  selectedPaymentMethod,
}) => {
  const [localSelection, setLocalSelection] = React.useState(
    data.find(d => d.value === selectedPaymentMethod) ?? data[0],
  )

  return (
    <Modal
      variant="default"
      btnType="text"
      footer
      action
      btnActionText="Save"
      footerCancel
      primaryFooterVariant="dark"
      openOnLoad
      btnAction={() => setSelectedPaymentMethod(localSelection.value)}
    >
      <ModalTitle variant="subtitle" size="lg">
        How would you like to process this transaction?
      </ModalTitle>
      <RadioGroup
        data={data}
        value={localSelection}
        onChange={e => {
          setLocalSelection(e)
        }}
        column
        layoutStyles={{
          gap: '20px',
        }}
      />
    </Modal>
  )
}

export {BillingOptionsModal}
